// Custom AI-Powered Products service page.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function CustomProducts() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.serviceB}
        eyebrow="Services · Craft"
        headline="Products built AI-native from"
        italicWord="day one."
        lede="We design and build AI-powered software from the ground up. No retrofitting. No bolt-ons."
      />

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              What AI-native actually means.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              An AI-native product is designed around the model from the start. The data pipeline, the
              user interface, the feedback loops and the monitoring are built to work together from day one.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We have seen what happens when AI is added to existing software late in development. It
              breaks under production load, confuses operators and gets switched off within a year.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              From discovery to live in weeks, not quarters.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Our process runs in four phases: discover, design, build, operate. Discovery takes two weeks.
              We map the problem, the data and the constraints. Design takes one week. We prototype the
              core AI behaviour and validate it with your operators before writing production code.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              Build and deploy typically runs four to ten weeks depending on scope. We ship to production,
              not a staging environment that never goes live.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You need software that uses AI at its core.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Predictive systems, computer vision pipelines, LLM-powered copilots, geospatial AI, dispatch
              optimisation and custom analytics platforms.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              If it needs AI at its core and it needs to work in a demanding industrial environment, we
              have built something like it before.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
